<script setup lang="ts"></script>
<template>
  <SidebarBlock variant="white" :heading-text="$t('widget.customer_care.title')">
    <p class="mb-3 text-sm leading-4">
      {{ $t('widget.customer_care.description') }}
    </p>
    <div class="rounded-md bg-gray-100 p-3 text-sm leading-4">
      <p class="mb-1 text-gray-600">{{ $t('widget.customer_care.schedule') }}</p>
      <a href="tel:+996555204444" class="font-serif font-bold text-blue-600 hover:underline"
        >+996 (555) 20 44 44</a
      >
    </div>
  </SidebarBlock>
</template>
